import React from 'react';

import { isEmpty, startCase } from 'lodash';
import PropTypes from 'prop-types';
import { faCircleExclamation } from '@awesome.me/kit-a6e51d954f/icons/classic/regular';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Alert } from '../../../../../shared/components/Alert';
import { Spinner } from '../../../../../shared/components/Spinner';
import { ERROR_TITLES } from '../../constants';
import { useStylesForm } from '../../hooks';
import Field from './Field/Field';
import FontFamilyCombinations from './FontFamilyCombinations/FontFamilyCombinations';

import componentStyles from './StylesForm.module.scss';
import sharedStyles from './_sharedStyles.module.scss';

const alertIcon = <FontAwesomeIcon icon={faCircleExclamation} />;

const StylesForm = ({ hidden, updateWebsiteSection }) => {
  const {
    errorMessage,
    handleSubmit,
    isLoading,
    isSubmitting,
    sectionSchemas,
    setThemeSettings,
    themeSettings,
  } = useStylesForm();

  if (isLoading) {
    return (
      <div className={sharedStyles.form__section}>
        <Spinner />
      </div>
    );
  }

  return (
    <div
      className={`${componentStyles.container} ${hidden ? componentStyles['container--hidden'] : ''}`}
    >
      <div className={sharedStyles.form}>
        <h3 className={sharedStyles.form__title}>Website Styles</h3>

        <form onSubmit={handleSubmit}>
          <FontFamilyCombinations
            setThemeSettings={setThemeSettings}
            themeSettings={themeSettings}
          />

          {sectionSchemas.map((section) => (
            <div className={sharedStyles.form__section} key={section.id}>
              <span className={sharedStyles.form__subtitle}>{startCase(section.id)}</span>

              {section.elements.map((element) => (
                <Field
                  attributes={element}
                  key={element.id}
                  sectionId={section.id}
                  setThemeSettings={setThemeSettings}
                  updateWebsiteSection={updateWebsiteSection}
                />
              ))}
            </div>
          ))}

          <button className="btn--primary" disabled={isSubmitting} type="submit">
            Update Website
          </button>
        </form>

        {!isEmpty(errorMessage) && (
          <Alert
            description={errorMessage}
            icon={alertIcon}
            title={ERROR_TITLES.styles.update}
            variant="destructive"
          />
        )}
      </div>
    </div>
  );
};

StylesForm.propTypes = {
  hidden: PropTypes.bool.isRequired,
  updateWebsiteSection: PropTypes.func.isRequired,
};

export default StylesForm;
